export const isAcLayout = (layout: string | undefined) =>
    layout === 'ac' || layout === '5:7'; // 5:7 is the old ac name
